var map = {
	"./DROP_DOWN.svg": 345,
	"./ic_arbitrum_16.svg": 890,
	"./ic_avalanche_16.svg": 891,
	"./ic_avax_40.svg": 531,
	"./ic_bnb_40.svg": 532,
	"./ic_btc_40.svg": 378,
	"./ic_coingecko_16.svg": 892,
	"./ic_convert_down.svg": 893,
	"./ic_copy_16.svg": 389,
	"./ic_eth_40.svg": 379,
	"./ic_frax_40.svg": 533,
	"./ic_glp_24.svg": 534,
	"./ic_glp_40.svg": 535,
	"./ic_link_40.svg": 536,
	"./ic_metamask_16.svg": 894,
	"./ic_mim_40.svg": 537,
	"./ic_new_link_16.svg": 390,
	"./ic_settings_16.svg": 391,
	"./ic_sign in_16.svg": 895,
	"./ic_sign_out_16.svg": 392,
	"./ic_uni_40.svg": 538,
	"./ic_usdc.e_40.svg": 539,
	"./ic_usdc_40.svg": 540,
	"./ic_usdt_40.svg": 541,
	"./ic_wavax_40.svg": 542,
	"./ic_wbnb_40.svg": 543,
	"./ic_weth_40.svg": 544,
	"./lever.svg": 896,
	"./long.svg": 897,
	"./short.svg": 898,
	"./swap.svg": 899,
	"./swapup.svg": 900,
	"./wave-01.png": 901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 889;